import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'

import urls from '../../../../../networkRequests/apiClient/endpoints'
import errorHandler from '../../../../../shared/functions/ErrorHandler/errorHandler.functions'
import { ApiErrorResponse } from '../../../../../shared/types/api.types'
import { getLockerMetricsApi } from './getLockerMetrics.api'
import getLockerMetricsInitialState from './getLockerMetrics.initialState'
import { GetLockerMetricsErrorResponse, GetLockerMetricsRequestPayload } from './getLockerMetrics.types'

export const getLockerMetrics = createAsyncThunk(
  urls.admin.getLockerMetrics,
  async (payload: GetLockerMetricsRequestPayload, { rejectWithValue }) => {
    const { request, onSuccess } = payload

    try {
      const response = await getLockerMetricsApi(request)

      onSuccess && onSuccess()

      return response
    } catch (error) {
      errorHandler.handleApiError(error as ApiErrorResponse)

      return rejectWithValue(error)
    }
  }
)

const getLockerMetricsSlice = createSlice({
  name: urls.admin.getLockerMetrics,
  initialState: getLockerMetricsInitialState,
  reducers: {
    resetGetLockerMetrics: (state) => {
      state.loading = false
      state.error = null
      state.success = null
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getLockerMetrics.pending, (state) => {
        state.loading = true
        state.error = null
        state.success = null
      })
      .addCase(getLockerMetrics.fulfilled, (state, { payload }) => {
        state.loading = false
        state.success = payload
        state.error = null
      })
      .addCase(getLockerMetrics.rejected, (state, { payload }) => {
        state.loading = false
        state.error = payload as GetLockerMetricsErrorResponse
        state.success = null
      })
  }
})

export const { actions: getLockerMetricsActions, reducer: getLockerMetricsReducer } = getLockerMetricsSlice
export const { resetGetLockerMetrics } = getLockerMetricsActions
export default getLockerMetricsSlice.reducer
